<template>
	<div class="leftbox" :class="{ 'pointer-events-none': isCameraActive }">
		<div class="leftbox-upper">
			<IncomeBox />

			<!-- 1. slot - quest alebo reklama -->
			<QuestBoxMap v-if="showQuestBox" />
			<AdBox v-else />

			<!-- 2. slot - eventovy offer -->
			<!-- 3. slot - max 2 dalsie offery -->
			<PremiumLeftBox />
			<SpecialBuildingPackLeftBox />

			<AdminResourcer v-if="IS_DEV || IS_QA" />
		</div>
		<div class="leftbox-lower">
			<RoyalProvisionLeftBox />
			<CameraResetButton />
			<AchievementMessage />
			<TaskTracker class="task-tracker-map" v-if="isRootPath" />
		</div>
	</div>
</template>

<script lang="ts" setup>
import AchievementMessage from "@/components/Achievements/AchievementMessage.vue";
import AdBox from "@/components/AdBox.vue";
import AdminResourcer from "@/components/AdminResourcer.vue";
import CameraResetButton from "@/components/CameraResetButton.vue";
import IncomeBox from "@/components/IncomeBox.vue";
import QuestBoxMap from "@/components/QuestBoxMap.vue";
import TaskTracker from "@/components/Quests/TaskTracker.vue";
import SpecialBuildingPackLeftBox from "@/components/shop/marketplace/SpecialBuildingPackLeftBox.vue";
import PremiumLeftBox from "@/components/shop/PremiumLeftBox.vue";
import RoyalProvisionLeftBox from "@/components/shop/RoyalProvisionLeftBox.vue";
import { IS_DEV, IS_QA } from "@/config/constants";
import useQuestStore from "@/store/useQuestStore";
import useRuntimeStore from "@/store/useRuntimeStore";
import { storeToRefs } from "pinia";
import { computed } from "vue";
import { useRoute } from "vue-router";

const questStore = useQuestStore();
const { tutorialActive, tutorialStep } = storeToRefs(questStore);
const { isCameraActive } = storeToRefs(useRuntimeStore());

const route = useRoute();

// TODO pridat pripadne dalsie podmienky pre zobrazenie quest boxu
const showQuestBox = computed(
	(): boolean => tutorialActive.value && tutorialStep.value === 7,
);

const isRootPath = computed((): boolean => route.name === "LayoutView");
</script>

<style lang="scss" scoped>
// dynamic value from HeaderComponent
$header-height: var(--header-total-height);

.leftbox {
	display: flex;
	position: absolute;
	top: $header-height;
	left: 0;
	@include flex-col-start;
	align-items: flex-start;
	gap: 1rem;
	padding: 0.375rem 0 0;
	height: calc(100% - var(--header-total-height) - var(--footer-height));
	overflow: hidden;
	pointer-events: none; // disable clicks on the background to allow map interactions

	&:not(.pointer-events-none) {
		// NOTE: for each new element in upper or lower, set auto only on specific button
		// and not on wrappers of those buttons through which the map can be interacted with
		:deep(.leftbox-upper) {
			.income-box,
			.quest-box-map,
			.ad-box,
			.premium-left-box__item,
			.special-building-pack-left-box,
			.admin-resourcer__btn {
				pointer-events: auto;
			}
		}

		:deep(.leftbox-lower) {
			.task-tracker-map,
			.camera-reset-button-overlay,
			.royal-provision-wrapper {
				pointer-events: auto;
			}
		}
	}

	.leftbox-upper,
	.leftbox-lower {
		display: flex;
		position: relative;
		flex: 1 1 auto;
		flex-direction: column;
		gap: 0.5rem;
	}

	.leftbox-upper {
		@include flex-col-start;
		align-items: flex-start;

		.tutorial-step-container {
			flex: 0 1 0;
		}
	}

	.leftbox-lower {
		@include flex-col-end;
		align-items: flex-start;
		margin-bottom: 0.5rem;
		padding-left: 0.5rem;

		.task-tracker-map {
			display: flex;
			position: relative;
			flex-direction: column;
			justify-content: center;
			min-height: 2.5rem;
		}
	}
}
</style>
